import React, { useState, useEffect } from "react";
import { getJourney, getCompanyProfile } from "services/About";
import DOMPurify from "dompurify";
import "./journey.css";

const AboutJourney = () => {
  const [journeyList, setJourneyList] = useState(null);
  const [companyProfile, setCompanyProfile] = useState(null);

  async function fetchJourney() {
    const result = await getJourney();

    setJourneyList(result);
  }

  async function fetchCompanyProfile() {
    const result = await getCompanyProfile();

    setCompanyProfile(result);
  }

  useEffect(() => {
    fetchJourney();
    fetchCompanyProfile();
  }, []);
  console.log("companyProfile", companyProfile);
  return (
    <>
      <div className="block relative py-[20px] md:pt-[140px] px-[16px] font-taviraj">
        <div className="max-w-[784px] mx-auto">
          <h2 className="text-32 md:text-[49px] text-neutral-100 leading-[55px] md:leading-[39.2px] tracking-[0.96px] mb-24 md:mb-[80px] md:pl-[8%]">
            Our Journey
          </h2>
          <div className="text-16 text-neutral-50 leading-[27px] pl-[20px]">
            {journeyList?.map((item, index) => (
              <div className="timeline-journey-item pb-32 md:pb-[78px] last:pb-0 relative pl-[35px]">
                <div className="timeline-journey-item-dot w-20 h-20 rounded-full border-[1px] border-[#BB8A3B] flex items-center justify-center absolute top-[6px] left-0">
                  <div className="timeline-journey-item-dot-inner w-[5px] h-[5px] bg-primary-600 rotate-[-45deg]"></div>
                </div>
                <div className="block custom-journey-description">
                  <span className="block text-20 leading-[34px]">
                    {item.year}
                  </span>
                  <div
                    className="block"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.description),
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        {companyProfile && (
          <div className="w-full max-w-[929px] mx-auto px-16 text-[#FFF9F6] mt-[43px] md:mt-[150px]">
            <div className="relative">
              <div className="w-full font-taviraj text-18 text-primary-600 overflow-hidden">
                <div className="whitespace-nowrap">
                  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                </div>
              </div>
              <div className="flex justify-center md:gap-[104px] py-[20px] md:py-[40px]">
                {companyProfile.map((item, index) => (
                  <div className="text-center w-1/3 md:w-auto" key={index}>
                    <h5 className="font-taviraj text-20 md:text-32 leading-[30px]">
                      {item.value}
                    </h5>
                    <span className="font-quicksand block text-[10px] md:text-20 leading-[12px] md:leading-[25px] mt-8 md:mt-12">
                      {item.title}
                    </span>
                  </div>
                ))}
              </div>
              <div className="w-full font-taviraj text-18 text-primary-600 overflow-hidden">
                <div className="whitespace-nowrap">
                  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AboutJourney;
